import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  gap: 4px;
  flex-direction: column;
`;

export const LinkContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  width: 200px;
  justify-content: center;
  white-space: nowrap;
  ${({ theme }) => `
    color: ${theme.colors.neutral.darkestNavy};
  `}
  button:hover {
    text-decoration: underline;
  }

  button:focus-visible {
    outline: 2px solid currentColor;
    outline-offset: 2px;
    border-radius: 2px;
  }

  @media ${({ theme }) => theme.queries.minTablet} {
    justify-content: flex-start;
  }
`;

export const LinkTextContainer = styled.button`
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  border: 0;
  background: transparent;
  padding: 0;
  color: inherit;
  font: inherit;
`;

export const LegalContainer = styled.div`
  line-height: 1;
  width: 100%;
  display: flex;
  justify-content: flex-start;

  @media ${({ theme }) => theme.queries.minTablet} {
    justify-content: flex-start;
  }

  @media ${({ theme }) => theme.queries.mobile} {
    justify-content: center;
    align-items: center;
    text-align: center;
    width: 100%;
  }
`;
